module.exports = __webpack_public_path__ + "img/parent-cat-5.f11c3d93.svg";